import React, { useContext, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { RiCloseFill } from "react-icons/ri";
import { toast } from 'react-toastify';
import { PopupContext } from '../../context/popupContext';
import { absentOptions, overtimeTypeOptions } from '../../utilities/selectOptions';
import { getFilteredOvertimes, getPendingOvertimes, updateOvertime } from '../../utilities/sendRequest';
import { convertToDateTimeLocal } from '../../utilities/helper';

const ModalOvertimeDetail = ({ setDatas, data, setShowModalDetail, startTime, endTime, divisionSlug }) => {
    const { popupDispatch } = useContext(PopupContext)
    const clickRef = useRef(null)
    const [isReady, setIsReady] = useState(false)
    const [fecthAgain, setFetchAgain] = useState(false)
    const [startDateTime, setStartDateTime] = useState(convertToDateTimeLocal(data.start_time))
    const [endDateTime, setEndDateTime] = useState(convertToDateTimeLocal(data.end_time))
    // const [startDateTime, setStartDateTime] = useState(data.start_time)
    // const [endDateTime, setEndDateTime] = useState(data.end_time)
    const [status, setStatus] = useState(data.status)
    const [type, setType] = useState(data.type)
    const [note, setNote] = useState(data.note)
    // const [photo, setPhoto] = useState("")
    const photo =""

    useEffect(() => {
        const isReady = (startDateTime !== "" && endDateTime !== "" && type !== "" && status !== "" && note !== "");
        setIsReady(isReady);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startDateTime, endDateTime, type, status, note])
    
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (clickRef.current && !clickRef.current.contains(event.target)) {
                setShowModalDetail(null)
                popupDispatch({ type: "POPUP_END" });
            }
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clickRef])

    useEffect(() => {
        setFetchAgain(false)
        if(fecthAgain) {
            fetchFilteredOvertime()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fecthAgain])

    const fetchFilteredOvertime = () =>{
        const startFilterTime = `${startTime} 00:00:00`
        const endFilterTime = `${endTime} 23:59:59`
        
        if(!startTime && !endTime) {
            getPendingOvertimes().then((res) => {
                setDatas(
                    res.payload.sort((p1, p2) => {
                        return new Date(p2.createdAt) - new Date(p1.createdAt)
                    })
                )
            }).catch((err) => {
                toast.error(err.response.data.message, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }).finally(() => {
                setShowModalDetail(false)
            })
        } else {
            getFilteredOvertimes(divisionSlug, startFilterTime, endFilterTime).then((res) => {
                setDatas(
                    res.payload.sort((p1, p2) => {
                        return new Date(p2.createdAt) - new Date(p1.createdAt)
                    })
                )
            }).catch((err) => {
                toast.error(err.response.data.message, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }).finally(() => {
                setShowModalDetail(false)
            })
        }
        popupDispatch({ type: "POPUP_END" });
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        setIsReady(false)

        const reqData = new FormData();
        reqData.append("start_time", startDateTime);
        reqData.append("end_time", endDateTime);
        reqData.append("type", type);
        reqData.append("status", status);
        reqData.append("note", note);

        if(photo) {
            reqData.append("photo", photo);
        }

        updateOvertime(data.id, reqData).then((res) => {
            toast.success(res.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }).catch((error) => {
            toast.error(error.response.data.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
        }).finally(() => {
            setIsReady(true)
            setFetchAgain(true)
        })
    }

    const handleModal = () => {
        setShowModalDetail(null)
        popupDispatch({ type: "POPUP_END" });
    }

    return (
        <div className="fixed inset-0 z-10 p-3 w-screen h-screen overflow-y-auto bg-black bg-opacity-70 flex items-start justify-center">
        {/* <div className="absolute top-0 left-0 z-10 p-3 w-screen min-h-screen overscroll-y-none overflow-y-hidden bg-black bg-opacity-70 flex items-center justify-center"> */}
            <div ref={clickRef} 
                className="p-3 w-11/12 lg:w-1/3 md:w-1/2 my-5 bg-white rounded-md flex flex-col"
                // className="p-3 w-11/12 lg:w-1/3 md:w-1/2 h-full bg-white rounded-md flex flex-col"
            >
                <div className="px-2 flex justify-between items-center">
                    <h3 className='font-bold font-ssp text-xl md:text-2xl'>Detail Overtime</h3>
                    <RiCloseFill onClick={handleModal} className='w-8 h-8 cursor-pointer'/>
                </div>
                <form onSubmit={handleSubmit} className='mt-5 px-5 w-full flex flex-col'>
                    {/* startDateTime */}
                    <div className="relative z-0 mb-3 mt-3 w-full group">
                        <input 
                            value={startDateTime} 
                            onChange={(e) => setStartDateTime(e.target.value)}
                            type="datetime-local" 
                            name="startDateTime" 
                            id="startDateTime" 
                            className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 
                                        appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer" 
                            placeholder=" " 
                            required
                        />
                        <label 
                            htmlFor="startDateTime" 
                            className="absolute top-3 -z-10 text-sm text-gray-500 dark:text-gray-400 
                                        duration-300 transform -translate-y-6 scale-75 origin-[0] peer-focus:font-medium
                                        peer-focus:left-0 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 
                                        peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                        >Strat Time</label>
                    </div>
                    {/* endDateTime */}
                    <div className="relative z-0 mb-3 mt-3 w-full group">
                        <input 
                            value={endDateTime} 
                            onChange={(e) => setEndDateTime(e.target.value)}
                            type="datetime-local" 
                            name="endDateTime" 
                            id="endDateTime" 
                            className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 
                                        appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer" 
                            placeholder=" " 
                            required
                        />
                        <label 
                            htmlFor="endDateTime" 
                            className="absolute top-3 -z-10 text-sm text-gray-500 dark:text-gray-400 
                                        duration-300 transform -translate-y-6 scale-75 origin-[0] peer-focus:font-medium
                                        peer-focus:left-0 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 
                                        peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                        >End Time</label>
                    </div>
                    {/* employee */}
                    <div className="relative z-0 mb-3 mt-3 w-full group">
                        <input 
                            value={data.Overtime_Requester.fullname+' - '+data.Overtime_Requester.nip}
                            type="text" 
                            name="employee" 
                            id="employee" 
                            className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 
                                        appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer" 
                            placeholder=" " 
                            required readOnly
                        />
                        <label 
                            htmlFor="employee" 
                            className="absolute top-3 -z-10 text-sm text-gray-500 dark:text-gray-400 
                                        duration-300 transform -translate-y-6 scale-75 origin-[0] peer-focus:font-medium
                                        peer-focus:left-0 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 
                                        peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                        >Employee</label>
                    </div>
                    {/* echelon */}
                    <div className="relative z-0 mb-3 mt-3 w-full group">
                        <input 
                            value={data.Overtime_Requester.Biodata.Echelon.title}
                            type="text" 
                            name="echelon" 
                            id="echelon" 
                            className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 
                                        appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer" 
                            placeholder=" " 
                            required readOnly
                        />
                        <label 
                            htmlFor="echelon" 
                            className="absolute top-3 -z-10 text-sm text-gray-500 dark:text-gray-400 
                                        duration-300 transform -translate-y-6 scale-75 origin-[0] peer-focus:font-medium
                                        peer-focus:left-0 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 
                                        peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                        >Eselon</label>
                    </div>
                    {/* office */}
                    <div className="relative z-0 mb-3 mt-3 w-full group">
                        <input 
                            value={data.Overtime_Requester.Biodata.Office.name}
                            type="text" 
                            name="office" 
                            id="office" 
                            className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 
                                        appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer" 
                            placeholder=" " 
                            required readOnly
                        />
                        <label 
                            htmlFor="office" 
                            className="absolute top-3 -z-10 text-sm text-gray-500 dark:text-gray-400 
                                        duration-300 transform -translate-y-6 scale-75 origin-[0] peer-focus:font-medium
                                        peer-focus:left-0 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 
                                        peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                        >Office</label>
                    </div>
                    {/* note */}
                    <div className="relative z-0 mb-3 mt-3 w-full group">
                        <input 
                            value={note} 
                            onChange={(e) => setNote(e.target.value)}
                            type="text" 
                            name="note" 
                            id="note" 
                            className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 
                                        appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer" 
                            placeholder=" " 
                            required
                        />
                        <label 
                            htmlFor="note" 
                            className="absolute top-3 -z-10 text-sm text-gray-500 dark:text-gray-400 
                                        duration-300 transform -translate-y-6 scale-75 origin-[0] peer-focus:font-medium
                                        peer-focus:left-0 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 
                                        peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                        >Note</label>
                    </div>
                    {/* type */}
                    <div className="mt-3 mb-6 w-full relative z-0 group">
                        <select 
                            required 
                            value={type} 
                            onChange={(e) => setType(e.target.value)} 
                            id="type" 
                            className="block py-2.5 px-2 w-full text-sm text-gray-500 bg-transparent 
                                        border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 
                                        focus:border-blue-600 peer"
                        >
                            {overtimeTypeOptions.map((option) => (
                                <option key={option.value} value={option.value} >{option.label}</option>
                            ))}
                        </select>
                        <label 
                            htmlFor="type" 
                            className="absolute top-3 -z-10 text-sm text-gray-500 
                                        duration-300 transform -translate-y-6 scale-75 origin-[0] peer-focus:left-0 peer-focus:font-medium 
                                        peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 
                                        peer-focus:scale-75 peer-focus:-translate-y-6"
                        >Type</label>
                    </div>
                    {/* {data.type === "Sakit"
                        ?
                            <>
                                {data.photo && 
                                    <div className="mt-3 w-full relative flex flex-row group">
                                        <img src={`${process.env.REACT_APP_PUBLIC_FOLDER_IMAGES}/${data.photo}`} alt="Berkas" className="w-full object-contain" />
                                    </div>
                                }
                                <div className="mb-3 mt-10 w-full relative z-0 group">
                                    <label 
                                        className="block mb-2 font-ssp text-sm font-medium text-gray-500" 
                                        htmlFor="file_input2"
                                    >Upload New Photo</label>
                                    <input 
                                        type="file" 
                                        name="photo"
                                        onChange={(e) => setPhoto(e.target.files[0])}
                                        accept='.png, .jpg, .jpeg'
                                        className="block w-full text-sm text-slate-500
                                                file:mr-4 file:py-2 file:px-4
                                                file:rounded-full file:border-0
                                                file:text-sm file:font-semibold
                                                file:bg-gray-50 file:text-gray-500
                                                hover:file:bg-gray-100"
                                    />
                                    <p className="mt-1 font-ssp text-xs text-gray-500 dark:text-gray-300" id="file_input2_help">PNG, JPG, JPEG (MAX. 5MB).</p>
                                </div>
                            </>
                        : ""
                    } */}
                    {/* status */}
                    <div className="mt-3 mb-6 w-full relative z-0 group">
                        <select 
                            required 
                            value={status} 
                            onChange={(e) => setStatus(e.target.value)} 
                            id="status" 
                            className="block py-2.5 px-2 w-full text-sm text-gray-500 bg-transparent 
                                        border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 
                                        focus:border-blue-600 peer"
                        >
                            {absentOptions.map((option) => (
                                <option key={option.value} value={option.value} >{option.label}</option>
                            ))}
                        </select>
                        <label 
                            htmlFor="status" 
                            className="absolute top-3 -z-10 text-sm text-gray-500 
                                        duration-300 transform -translate-y-6 scale-75 origin-[0] peer-focus:left-0 peer-focus:font-medium 
                                        peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 
                                        peer-focus:scale-75 peer-focus:-translate-y-6"
                        >Status</label>
                    </div>
                    {data.Overtime_Approver
                        ?
                            <div className="relative z-0 mb-3 mt-3 w-full group">
                                <input 
                                    value={data.Overtime_Approver.fullname+' - '+data.Overtime_Approver.nip}
                                    type="text" 
                                    name="admin" 
                                    id="admin" 
                                    className="block py-2.5 px-2 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 
                                                appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer" 
                                    placeholder=" " 
                                    required readOnly
                                />
                                <label 
                                    htmlFor="admin" 
                                    className="absolute top-3 -z-10 text-sm text-gray-500 dark:text-gray-400 
                                                duration-300 transform -translate-y-6 scale-75 origin-[0] peer-focus:font-medium
                                                peer-focus:left-0 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 
                                                peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                                >Admin</label>
                            </div>
                        : ""
                    }
                    {/* Button */}
                    <div className="mb-6 mt-5 w-full relative z-0 flex gap-3 justify-end">
                        <button type="submit" 
                            disabled={!isReady}
                            className={`mt-5 px-5 py-2.5 w-full sm:w-auto ${isReady ? 'text-white bg-blue-400 hover:bg-blue-500 cursor-pointer' : 'text-gray-800 bg-gray-300 cursor-wait'} rounded-lg text-sm
                                        text-center font-medium`}
                        >Submit</button>
                        <button onClick={handleModal} 
                            className="px-5 py-2.5 mt-5 w-full sm:w-auto bg-red-400 hover:bg-red-500 rounded-lg text-sm text-white
                                        text-center font-medium cursor-pointer"
                        >Close</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

ModalOvertimeDetail.propTypes = {
    data: PropTypes.object,
    setDatas: PropTypes.func,
    setShowModalDetail: PropTypes.func,
    startTime: PropTypes.string,
    endTime: PropTypes.string,
    divisionSlug: PropTypes.string,
}

export default ModalOvertimeDetail